export const theme = {
  black: '#0f1113',
  white: '#ffffff',
  darkGray: '#1e2227',
  lightGray: '#23272e',
  selected: '#ef5350',
  disabled: '#9e9e9e',
  info: '#01579b',
  red: '#c62828',
  advanced: '#b71c1c',
  intermediate: '#e65100',
  beginner: '#0288d1',
};
